import type { ReactNode } from 'react';

export const symbol_category_search: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M110-145q-12.75 0-21.37-8.63Q80-162.25 80-175v-244q0-12.75 8.63-21.38Q97.25-449 110-449h244q12.75 0 21.38 8.62Q384-431.75 384-419v244q0 12.75-8.62 21.37Q366.75-145 354-145H110Zm30-60h184v-184H140v184Zm467-361H275q-17.5 0-26.25-15.5T249-612l167-267q8.79-14 24.89-14Q457-893 466-879l167 267q9 15 .25 30.5T607-566Zm-278-60h224L441-807 329-626ZM849-73l-80-79q-22 15-48.11 23.5T666-120q-74 0-124-50t-50-124q0-74 50-124t124-50q74 0 124 50t50 124q0 28-7.52 52.5T811-196l81 81q9 9 9 21t-9 21q-9 9-21.5 9T849-73ZM747-213.08q33-33.09 33-81Q780-342 746.92-375q-33.09-33-81-33Q618-408 585-374.92q-33 33.09-33 81Q552-246 585.08-213q33.09 33 81 33Q714-180 747-213.08ZM324-389Zm117-237Z"
		/>
	</svg>
);
